<template>
  <div>
    <el-dialog
        :title="fullNameTitle"
        :visible.sync="dialogVisible"
        width="1000px"
        :before-close="closeDialog"
        :close-on-click-modal="false"
    >
      <el-form
          label-width="120px"
          :model="attendanceKidFormModel"
          label-position="top"
          ref="attendanceKid"
      >
        <el-row :gutter="20" style="margin-top:10px">
          <el-col
              v-for="shift in shiftList"
              :key="shift.shiftId"
              :span="24"
          >
            <div class="shift-card" v-if="shift.id != null">
              <!-- TÊN CA -->
              <div class="shift-header">
                <strong>{{ shift.shiftName }}</strong>
              </div>

              <div class="shift-row">
                <!-- Ảnh đến -->
                <div class="shift-col shift-media">
                  <div class="shift-media-title">Ảnh đến</div>
                  <image-uploader
                      v-model="shift.checkinImage"
                      :preview="shift.checkinImageUrl"
                      placeholder="Tải ảnh đến"
                      :updateAttendance="updateAttendance"
                  />
                  <div class="shift-time">
                    Giờ đến: <span>{{ shift.checkinTime | formatTime }}</span>
                  </div>
                </div>

                <!-- Ảnh về -->
                <div class="shift-col shift-media">
                  <div class="shift-media-title">Ảnh về</div>
                  <image-uploader
                      v-model="shift.checkoutImage"
                      :preview="shift.checkoutImageUrl"
                      placeholder="Tải ảnh về"
                      :disabled="!updateAttendance"
                  />
                  <div class="shift-time">
                    Giờ về: <span>{{ shift.checkoutTime | formatTime }}</span>
                  </div>
                </div>

                <!-- Note -->
                <div class="shift-col shift-note">
                  <div class="shift-media-title">Ghi chú</div>
                  <!-- Disable textarea -->
                  <el-input
                      type="textarea"
                      :rows="3"
                      placeholder="Nhập ghi chú cho ca"
                      v-model="shift.note"
                      :disabled="!updateAttendance"
                  />
                  <div class="shift-status">
                    Trạng thái:
                    <strong :class="statusClass(shift.status)">
                      <i :class="statusIcon(shift.status)"></i>
                      {{ statusLabel(shift.status) }}
                    </strong>
                  </div>

                  <div class="shift-late-info"
                       v-if="shift.lateCheckinMinutes > 0 || shift.earlyCheckoutMinutes > 0 || shift.lateCheckoutMinutes > 0">
                    <el-col :span="8" v-if="shift.lateCheckinMinutes > 0">
                      <span class="late-icon">⏰</span>
                      <strong>Đến muộn:</strong> {{ shift.lateCheckinMinutes }} phút
                    </el-col>
                    <el-col :span="8" v-if="shift.earlyCheckoutMinutes > 0">
                      <span class="late-icon">🏃</span>
                      <strong>Về sớm:</strong> {{ shift.earlyCheckoutMinutes }} phút
                    </el-col>
                    <el-col :span="8" v-if="shift.lateCheckoutMinutes > 0">
                      <span class="late-icon">🕐</span>
                      <strong>Về muộn:</strong> {{ shift.lateCheckoutMinutes }} phút
                    </el-col>
                  </div>

                  <div>
                    <el-button
                        type="primary"
                        size="small"
                        @click="historyAttendance(shift.id)"
                        style="margin-top: 10px"
                    >
                      Lịch sử thay đổi
                    </el-button>
                  </div>
                </div>
              </div>
            </div>

            <el-divider v-if="shift.id != null" />
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
      <el-button
          v-if="updateAttendance"
          type="success"
          size="medium"
          :loading="loadingButton"
          @click="submitForm('attendanceKid')"
      >
        <i class="el-icon-circle-check"/> Lưu
      </el-button>
         <el-button type="danger" size="medium" @click="closeDialogByButton()">
        <i class="el-icon-circle-close"/> Đóng
      </el-button>
    </span>
    </el-dialog>
    <div>
      <HistoryUpdateAttendanceDialog
          :recordId="recordId"
          :showHistoryUpdateAttendance="showHistoryUpdateAttendance"
          @dialog-close="handleCloseHistoryUpdateAttendance"
      />
    </div>
  </div>
</template>

<script>
import ImageUploader from "@/utils/view/ImageUploader.vue";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import shiftMaster from "@/services/ShiftMaster";
import HistoryUpdateAttendanceDialog from "@/views/attendance-v2/dialog/HistoryUpdateAttendanceDialog.vue";

export default {
  name: "AttendanceDialogPerShift",
  components: {
    ImageUploader,
    HistoryUpdateAttendanceDialog
  },
  props: {
    dialogVisible: { type: Boolean, default: false },
    updateAttendance: { type: Boolean, default: false },
  },
  data() {
    return {
      recordId: "",
      attendanceKidFormModel: {},
      attendanceKidRow: null,
      fullNameTitle: "",
      loadingButton: false,
      shiftList: [],
      teamId: "",
      attendanceRecordDate: "",
      showHistoryUpdateAttendance: false,
    };
  },
  methods: {
    // ==================== TRẠNG THÁI ====================
    statusLabel(status) {
      switch (status) {
        case "PRESENT": return "Đi học";
        case "EXCUSED_ABSENT": return "Nghỉ có phép";
        case "UNEXCUSED_ABSENT": return "Nghỉ không phép";
        case "NOT_CHECKED_IN": return "Chưa điểm danh";
        case "LATE": return "Đi muộn";
        default: return status || "Chưa điểm danh";
      }
    },

    statusClass(status) {
      switch (status) {
        case "PRESENT": return "status-present";
        case "EXCUSED_ABSENT":
        case "UNEXCUSED_ABSENT": return "status-absent";
        case "LATE": return "status-late";
        case "NOT_CHECKED_IN":
        default: return "status-none";
      }
    },

    statusIcon(status) {
      switch (status) {
        case "PRESENT": return "el-icon-circle-check";
        case "EXCUSED_ABSENT": return "el-icon-info";
        case "UNEXCUSED_ABSENT": return "el-icon-warning";
        case "NOT_CHECKED_IN": return "el-icon-question";
        case "LATE": return "el-icon-time";
        default: return "el-icon-minus";
      }
    },

    // ==================== DIALOG CONTROL ====================
    closeDialog(done) {
      this.clearUploadedFiles();

      if (this.$refs["attendanceKid"]) {
        setTimeout(() => {
          try {
            this.$refs["attendanceKid"].resetFields();
          } catch (e) {
            console.log(e);
          }
        }, 200);
      }
      this.$emit("dialog-close", false);
      if (typeof done === "function") done();
    },

    closeDialogByButton() {
      this.closeDialog();
    },

    clearUploadedFiles() {
      this.shiftList.forEach(shift => {
        this.$set(shift, "checkinImage", null);
        this.$set(shift, "checkoutImage", null);
      });
      this.shiftList = [];
      this.attendanceKidRow = null;
      this.fullNameTitle = "";
      this.recordId = "";
      this.showHistoryUpdateAttendance = false;
    },

    // ==================== LƯU ĐIỂM DANH ====================
    submitForm(formRef) {
      if (!this.$refs[formRef]) {
        this.$message.error("Form ref không tồn tại");
        return;
      }

      this.$refs[formRef].validate(async (valid) => {
        if (!valid) {
          this.$message.error("Vui lòng kiểm tra thông tin trước khi lưu");
          return;
        }

        const requests = this.shiftList.map(shift => {
          const formData = new FormData();

          formData.append("teamId", this.teamId || "");
          formData.append("targetType", this.attendanceKidRow?.targetType || "STUDENT");
          formData.append("targetId", this.attendanceKidRow?.targetId || "");
          formData.append("shiftMasterId", shift.shiftId);
          formData.append("attendanceRecordDate", this.attendanceRecordDate || "");

          if (shift.checkinTime) formData.append("checkinTime", shift.checkinTime);
          if (shift.checkoutTime) formData.append("checkoutTime", shift.checkoutTime);
          if (shift.status) formData.append("status", shift.status);
          if (shift.note) formData.append("note", shift.note);

          if (shift.checkinImage instanceof File) {
            formData.append("checkinImage", shift.checkinImage, `checkin_${shift.shiftId}.jpg`);
          }
          if (shift.checkoutImage instanceof File) {
            formData.append("checkoutImage", shift.checkoutImage, `checkout_${shift.shiftId}.jpg`);
          }

          return formData;
        });

        this.loadingButton = true;

        try {
          let hasError = false;
          let errorMessages = [];

          // Gửi tuần tự để dễ debug
          for (let i = 0; i < requests.length; i++) {
            const formData = requests[i];
            const shift = this.shiftList[i];

            try {
              const response = await shiftMaster.saveAttendanceRecordOne(formData);

              if (!response || response.status !== 200) {
                hasError = true;
                errorMessages.push(`Ca ${shift.shiftName} lưu thất bại`);
              }
            } catch (err) {
              hasError = true;
              console.error(`Lỗi lưu ca ${shift.shiftName}:`, err);
              errorMessages.push(`Ca ${shift.shiftName}: ${err.response?.data?.message || "Lỗi không xác định"}`);
            }
          }

          if (hasError) {
            this.$message.error("Một số ca lưu thất bại:\n" + errorMessages.join("\n"));
          } else {
            NotifyMessage.leftCornerNotificationSuccess("Cập nhật điểm danh học sinh thành công");
          }

          this.clearUploadedFiles();
          this.closeDialogByButton();

        } catch (err) {
          console.error("Lỗi tổng quát:", err);
          this.$message.error("Cập nhật điểm danh học sinh thất bại");
        } finally {
          this.loadingButton = false;
        }
      });
    },

    // ==================== KHỞI TẠO DỮ LIỆU ====================
    getDataArriveRowInitial(teamId, date, row) {
      if (!row) return;

      this.attendanceKidRow = row;
      this.teamId = teamId;
      this.attendanceRecordDate = date;

      this.shiftList = (row.attendanceRecordList || []).map(item => ({
        id: item.id ?? null,
        shiftId: item.shiftId,
        shiftName: (item.shiftName || "").trim(),
        checkinTime: item.checkinTime || null,
        checkoutTime: item.checkoutTime || null,
        checkinImageUrl: item.checkinImageUrl || null,
        checkoutImageUrl: item.checkoutImageUrl || null,
        checkinImage: null,
        checkoutImage: null,
        note: item.note || null,
        status: item.status || null,
        apply: item.apply ?? true,
        lateCheckinMinutes: item.lateCheckinMinutes || null,
        earlyCheckoutMinutes: item.earlyCheckoutMinutes || null,
        lateCheckoutMinutes: item.lateCheckoutMinutes || null,
      }));

      this.fullNameTitle = "Thông tin điểm danh: " + (row.targetName || "");
    },

    // ==================== LỊCH SỬ THAY ĐỔI ====================
    historyAttendance(recordId) {
      this.recordId = recordId;
      this.showHistoryUpdateAttendance = true;
    },

    handleCloseHistoryUpdateAttendance() {
      this.showHistoryUpdateAttendance = false;
    }
  }
};
</script>

<style scoped>
/* Giữ nguyên toàn bộ style cũ */
.shift-card {
  padding: 18px;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #dcdcdc;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
}

.shift-row {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.shift-col {
  display: flex;
  flex-direction: column;
}

.shift-media {
  width: 160px;
  align-items: center;
}

.shift-note {
  flex: 1;
}

.shift-status {
  margin-top: 10px;
  font-size: 13px;
}

.shift-status strong {
  padding: 4px 10px;
  border-radius: 6px;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  gap: 6px; /* Khoảng cách giữa icon và text */
}

/* Icon chung */
.shift-status strong i {
  font-size: 16px;
  font-weight: bold;
}

/* Các trạng thái cụ thể */
.status-present {
  background: #e2f8ec;
  color: #0a8a45;
}

.status-present i {
  color: #0a8a45;
}

.status-absent {
  background: #ffe3e3;
  color: #d32f2f;
}

.status-absent i {
  color: #d32f2f;
}

.status-late {
  background: #fff4e1;
  color: #e67e22;
}

.status-late i {
  color: #e67e22;
}

.status-none {
  background: #eeeeee;
  color: #666;
}

.status-none i {
  color: #666;
}

.shift-time {
  margin-top: 6px;
  color: #4177e2;
  font-size: 16px;
}

/* Các style dialog giữ nguyên */
::v-deep .el-dialog__body {
  max-height: 68vh;
  overflow-y: auto;
  background: #fafbff;
  padding-top: 15px !important;
  padding-bottom: 10px !important;
}

::v-deep .el-dialog__header {
  background: linear-gradient(135deg, #4da3ff, #1f74d4);
  padding: 16px 20px !important;
  border-bottom: 2px solid #d0e7ff;
}

::v-deep .el-dialog__title {
  color: white !important;
  font-size: 20px !important;
  font-weight: bold;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: white !important;
  font-size: 18px;
}

::v-deep .el-dialog__footer {
  background: #f5f7fa;
  padding: 14px 20px !important;
  border-top: 1px solid #dcdfe6;
}

::v-deep .el-button--danger:hover {
  background: #ff6b6b;
  border-color: #ff6b6b;
}

::v-deep .el-button--success:hover {
  background: #40c463;
  border-color: #40c463;
}

/* Phần hiển thị Đến muộn / Về sớm / Về muộn */
.shift-late-info {
  margin-top: 12px;
  padding: 8px 12px;
  background: #eeeff4;
  border-radius: 6px;
  border: 1px solid #eeeff4;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 13px;
  color: #d4380d; /* Màu đỏ cam nổi bật */
}

.shift-late-info .el-col {
  margin: 0;
  padding: 0;
  flex: 1;
  min-width: 120px; /* Đảm bảo không bị co quá nhỏ */
  text-align: center;
}

/* Nếu muốn chữ in đậm */
.shift-late-info strong {
  font-weight: 600;
}

/* Tùy chọn: thêm icon nhỏ nếu muốn đẹp hơn */
.shift-late-info .late-icon {
  margin-right: 4px;
  font-size: 14px;
}
</style>